export enum dataHooks {
  track = 'track',
  knob = 'knob',
  knobIcon = 'knob-icon',
  toggleSwitchInput = 'toggle-switch-input',
}
